import { QuestionSearchItem } from '@core/types/types.common';
import { DBQuestion } from '@core/types/types.db';
import { QuestionVerifyEndpoint } from '@core/types/types.endpoint.question';
import { useBroadcaster } from '@frontend/shared/hooks/shared.hook.useBroadcaster';
import { useSubmitter } from '@frontend/shared/hooks/useSubmitter';
import { callApi } from '@frontend/shared/util/util.callApi';
import { Editor } from '@tiptap/react';

export function useSaver(
  question: Pick<
    DBQuestion | QuestionSearchItem,
    'title' | 'id' | 'answer_json' | 'verified_by' | 'category_id'
  >,
  title: string,
  editor: Editor | null,
  categoryId?: string,
  onCompleted?: () => void,
) {
  const broadcast = useBroadcaster();

  return useSubmitter(async () => {
    const trimmed = title.trim();
    const newAnswerJson = JSON.stringify(editor?.getJSON());

    if (!editor || !trimmed) return;
    if (
      trimmed !== question.title ||
      newAnswerJson !== question.answer_json ||
      categoryId !== question.category_id ||
      question.verified_by === 'UNVERIFIED'
    ) {
      const [, res] = await callApi<QuestionVerifyEndpoint>(
        '/question/verify',
        {
          title: trimmed,
          id: question.id,
          answerBase64: btoa(encodeURIComponent(newAnswerJson)),
          category_id: categoryId,
        },
      );

      if (res) {
        broadcast({
          event: 'question:save',
          question: res,
        });
        onCompleted?.();
      }
    }
  });
}
